<script>
import HeroComp from "@/components/Hero.vue";

export default {
  name: "app",
  components: {
    HeroComp,
  },
};
</script>
<template>
  <div>
    <header>
      <Navigatie />
    </header>
    <HeroComp v-if="this.$route.name === 'Home'" />
    <main>
      <router-view></router-view>
    </main>

    <footer>
      <FooterSection />
    </footer>
    <button v-if="innerScrollHeight" @click="toTop()" class="top-btn" type="button">&uarr;</button>
  </div>
</template>

<style scoped>
main {
  min-height: auto;
  min-width: 100%;
  margin: 0 auto;
}
</style>
